module.exports = __webpack_public_path__ + "images/fordc1e69ff9a2fc1a8d8305fad0f3f6691c.png";